import { render } from "./HeroiconsOutlineWifi.vue?vue&type=template&id=4f89011a"
const script = {}

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineWifi.vue"]])

export default __exports__